export default __webpack_public_path__ + "static/media/Icon-Fertility.7ab59e2e.svg";